import { render, staticRenderFns } from "./GDynamicIcon.vue?vue&type=template&id=02768516&"
import script from "./GDynamicIcon.vue?vue&type=script&lang=js&"
export * from "./GDynamicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports